(function() {
    $(document).ready(function() {

        $('.c24m-contact-icon').on('click', function() {
            window._paq.push([
                'trackEvent',
                'NavKontakt',
                'Kontakt_seen_click',
                'mobile',
            ]);
        });

        $('.c24m-contact-layer-content a').on('click', function() {
            window._paq.push([
                'trackEvent',
                'NavKontakt',
                'Kontakt_email_clicked',
                'desktop',
            ]);
        });
    });
})();
